import React from 'react';
import { useRecoilValue } from 'recoil';
import OtherBankUntilRegistration from './OtherBankUntilRegistration';
import OtherBankUntilRelease from './OtherBankUntilRelease';
import OtherBankDeliveryMoneyWithConsignmentPrice from './OtherBankDeliveryMoneyWithConsignmentPrice';
import OtherBankDeliveryMoneyWithoutConsignmentPrice from './OtherBankDeliveryMoneyWithoutConsignmentPrice';
import { otherBankInfoState } from '../../../../../data/estimate/common/otherBank/info/selector';

/**
 *  타금융사 할부조건 payment 타입별 묶음 contents
 *  */
function OtherBankPaymentContents(): JSX.Element {
  // selected
  const principalType: string = useRecoilValue(
    otherBankInfoState({ name: 'otherBankPrincipalType' })
  );
  const isDisabled: boolean = principalType !== 'paymentType';
  const paymentType: string = useRecoilValue(otherBankInfoState({ name: 'otherBankPaymentType' }));

  return (
    <>
      {(paymentType === 'availableAmount' || paymentType === 'untilRegistration') && (
        <OtherBankUntilRegistration isDisabled={isDisabled} />
      )}
      {paymentType === 'untilRelease' && <OtherBankUntilRelease isDisabled={isDisabled} />}
      {paymentType === 'deliveryMoneyWithConsignmentPrice' && (
        <OtherBankDeliveryMoneyWithConsignmentPrice isDisabled={isDisabled} />
      )}
      {paymentType === 'deliveryMoneyWithoutConsignmentPrice' && (
        <OtherBankDeliveryMoneyWithoutConsignmentPrice isDisabled={isDisabled} />
      )}
    </>
  );
}

export default OtherBankPaymentContents;
